import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Text customization", -1)
const _hoisted_3 = { class: "card col-md-6" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  for: "name",
  class: "form-label"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", null, "Mostly this is equivalent to the actual company name.", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  for: "name",
  class: "form-label"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", null, "The company slogan or something geneeric like: \"You were invited to participate in\"", -1)
const _hoisted_11 = { class: "card-footer" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.loading ? "Loading" : "Customer facing company name"), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "name",
            placeholder: "Company name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.org.config.displayName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.org.config.displayName]
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.loading ? "Loading" : "Customer facing workspace claim"), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "claim",
            placeholder: "Workspac claim",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.org.config.texts.claim) = $event))
          }, null, 512), [
            [_vModelText, _ctx.org.config.texts.claim]
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ms-2 float-end",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          disabled: _ctx.submitted
        }, _toDisplayString(_ctx.submitted ? "Storing" : "Update"), 9, _hoisted_12)
      ])
    ])
  ]))
}